import { render, staticRenderFns } from "./AnalysesListController.vue?vue&type=template&id=d2c894f6&scoped=true&"
import script from "./AnalysesListController.vue?vue&type=script&lang=ts&"
export * from "./AnalysesListController.vue?vue&type=script&lang=ts&"
import style0 from "./analyses-list.scss?vue&type=style&index=0&id=d2c894f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c894f6",
  null
  
)

export default component.exports